export default "__VITE_ASSET__LfOtv0Kh__"